import React, { useState } from 'react';
import apiService from '../../services/api';
import './TranscriptionPage.css';

const TranscriptionPage: React.FC = () => {
  const [audioUrl, setAudioUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [transcript, setTranscript] = useState('');

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError(null);
      setTranscript('');

      if (!audioUrl.trim()) {
        setError('Please enter an audio URL');
        setLoading(false);
        return;
      }

      const data = await apiService.postText('/transcription/start', {
        url: audioUrl,
      });
      setTranscript(data);
    } catch (e: any) {
      setError(e?.message || 'Failed to fetch transcript');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="transcription-page">
      <div className="transcription-header">
        <h1>Transcription</h1>
        <p>Manage and view your transcriptions here.</p>
      </div>

      <div className="transcription-content">
        <div className="transcription-form">
          <label htmlFor="audio-url" className="form-label">
            Audio URL
          </label>
          <input
            id="audio-url"
            type="url"
            placeholder="Enter the audio url"
            value={audioUrl}
            onChange={e => setAudioUrl(e.target.value)}
            className="form-input"
          />
          <button
            className="submit-button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
          {error && <div className="error-text">{error}</div>}
        </div>

        <div className="transcript-output">
          <label className="form-label">Transcript</label>
          <textarea
            className="transcript-textarea"
            placeholder="Transcript will appear here"
            value={transcript}
            readOnly
          />
        </div>
      </div>
    </div>
  );
};

export default TranscriptionPage;
